"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRSPSysToken = exports.rspSysTokens = void 0;
var colors_1 = require("./colors");
var elevations_1 = require("./elevations");
var shapes_1 = require("./shapes");
var typescales_1 = require("./typescales");
exports.rspSysTokens = __assign(__assign(__assign(__assign({}, colors_1.rspSysColorToken), elevations_1.rspSysElevationToken), shapes_1.rspSysShapeToken), typescales_1.rspSysTypescaleToken);
var isRSPSysToken = function (tokenKey) {
    return typeof tokenKey === 'string' && Object.keys(exports.rspSysTokens).indexOf(tokenKey) > -1;
};
exports.isRSPSysToken = isRSPSysToken;
//# sourceMappingURL=sys-tokens.js.map